import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

import { AppWrap } from '../../wrapper';
import { urlFor, client } from '../../client';
import './Skills.scss';


const Skills = () => {
  const [languages, setLanguages] = useState([]);

  useEffect(() => {
    const languagesQuery = '*[_type == "languages"]';

    client.fetch(languagesQuery)
    .then((data) => {
      setLanguages(data);
    });
}, [])

const [webtechs, setWebtechs] = useState([]);

useEffect(() => {
  const webtechsQuery = '*[_type == "webtechs"]';

  client.fetch(webtechsQuery)
  .then((data) => {
    setWebtechs(data);
  });
}, [])

const [frameworks, setFrameworks] = useState([]);

useEffect(() => {
  const frameworksQuery = '*[_type == "frameworks"]';

  client.fetch(frameworksQuery)
  .then((data) => {
    setFrameworks(data);
  });
}, [])

const [tools, setTools] = useState([]);

useEffect(() => {
  const toolsQuery = '*[_type == "tools"]';

  client.fetch(toolsQuery)
  .then((data) => {
    setTools(data);
  });
}, [])

const [versioncontrols, setVersioncontrols] = useState([]);

useEffect(() => {
  const versioncontrolsQuery = '*[_type == "versioncontrols"]';

  client.fetch(versioncontrolsQuery)
  .then((data) => {
    setVersioncontrols(data);
  });
}, [])

const [platforms, setPlatforms] = useState([]);

useEffect(() => {
  const platformsQuery = '*[_type == "platforms"]';

  client.fetch(platformsQuery)
  .then((data) => {
    setPlatforms(data);
  });
}, [])


  return (
    <>
      <h2 className="head-text">My <span>Skills</span></h2>

      <div className="app__skills-container">
        <div className="languages">
          <p className='skillName'>Programming Languages</p>
          <motion.div className="app__skills-list">
            {languages.map((language) => (
              <motion.div
                whileInView={{opacity: [0,1]}}
                transition={{duration:0.5}}
                className="app__skills-item app__flex"
                key={language.name}
              >
                <div className = "app__flex" style={{backgroundColor:language.bgColor}}>
                  <img src={urlFor(language.icon)} alt={language.name} />
                </div>
                <p className="p-text">{language.name}</p>
              </motion.div>
            ))}
          </motion.div>
        </div>

        <div className="webtech">
          <p className='skillName'>Web Technologies</p>
          <motion.div className="app__skills-list">
            {webtechs.map((webtech) => (
              <motion.div
                whileInView={{opacity: [0,1]}}
                transition={{duration:0.5}}
                className="app__skills-item app__flex"
                key={webtech.name}
              >
                <div className = "app__flex" style={{backgroundColor:webtech.bgColor}}>
                  <img src={urlFor(webtech.icon)} alt={webtech.name} />
                </div>
                <p className="p-text">{webtech.name}</p>
              </motion.div>
            ))}
          </motion.div>
        </div>

        <div className="frameworks">
          <p className='skillName'>Frameworks</p>
          <motion.div className="app__skills-list">
            {frameworks.map((framework) => (
              <motion.div
                whileInView={{opacity: [0,1]}}
                transition={{duration:0.5}}
                className="app__skills-item app__flex"
                key={framework.name}
              >
                <div className = "app__flex" style={{backgroundColor:framework.bgColor}}>
                  <img src={urlFor(framework.icon)} alt={framework.name} />
                </div>
                <p className="p-text">{framework.name}</p>
              </motion.div>
            ))}
          </motion.div>
        </div>

        <div className="tools">
          <p className='skillName'>Tools</p>
          <motion.div className="app__skills-list">
            {tools.map((tool) => (
              <motion.div
                whileInView={{opacity: [0,1]}}
                transition={{duration:0.5}}
                className="app__skills-item app__flex"
                key={tool.name}
              >
                <div className = "app__flex" style={{backgroundColor:tool.bgColor}}>
                  <img src={urlFor(tool.icon)} alt={tool.name} />
                </div>
                <p className="p-text">{tool.name}</p>
              </motion.div>
            ))}
          </motion.div>
        </div>

        <div className="versioncontrol">
          <p className='skillName'>Version Control</p>
          <motion.div className="app__skills-list">
            {versioncontrols.map((versioncontrol) => (
              <motion.div
                whileInView={{opacity: [0,1]}}
                transition={{duration:0.5}}
                className="app__skills-item app__flex"
                key={versioncontrol.name}
              >
                <div className = "app__flex" style={{backgroundColor:versioncontrol.bgColor}}>
                  <img src={urlFor(versioncontrol.icon)} alt={versioncontrol.name} />
                </div>
                <p className="p-text">{versioncontrol.name}</p>
              </motion.div>
            ))}
          </motion.div>
        </div>

        <div className="platforms">
          <p className='skillName'>Platforms</p>
          <motion.div className="app__skills-list">
            {platforms.map((platform) => (
              <motion.div
                whileInView={{opacity: [0,1]}}
                transition={{duration:0.5}}
                className="app__skills-item app__flex"
                key={platform.name}
              >
                <div className = "app__flex" style={{backgroundColor:platform.bgColor}}>
                  <img src={urlFor(platform.icon)} alt={platform.name} />
                </div>
                <p className="p-text">{platform.name}</p>
              </motion.div>
            ))}
          </motion.div>
        </div>

      </div>
    </>
  )
}

export default AppWrap(Skills, 'skills'); 